import { __awaiter } from "tslib";
import { combine } from "@pnp/common";
import { _List, List } from "../lists/types.js";
import { SiteScripts } from "./types.js";
import "../folders/list.js";
import { Web } from "../webs/types.js";
import { extractWebUrl } from "../utils/extractweburl.js";
_List.prototype.getSiteScript = function () {
    return __awaiter(this, void 0, void 0, function* () {
        const rootFolder = yield this.clone(List).rootFolder.get();
        const web = yield Web(extractWebUrl(this.toUrl())).select("Url").get();
        const absoluteListUrl = combine(web.Url, "Lists", rootFolder.Name);
        return SiteScripts(this, "").getSiteScriptFromList(absoluteListUrl);
    });
};
//# sourceMappingURL=list.js.map